// Primeiro acesso com conta: o perfil de jogador, sugerindo o primeiro nome da conta Google. A conta Google informa o
// celular aqui, com a caixa opcional dos avisos pelo WhatsApp, e só continua com um número válido. O celular é gravado
// antes do perfil: número recusado (já em outra conta, muitas tentativas) segura a pessoa nesta tela, e o número que
// já ficou gravado volta preenchido.
import { useEffect, useState } from 'react';
import { ErroDaApi, avisarPerfilCompleto } from '../comum/api.ts';
import { celularValido, guardarMeuCelular, lerMeuCelular, mascararDigitando } from '../comum/celular.ts';
import { PERFIL_VAZIO, conta, type PerfilConta, type Sessao } from '../comum/conta.ts';
import { cadastrou } from '../comum/cadastro.ts';
import { CaixaAvisos, CampoCelular } from '../comum/FolhaCelular.tsx';
import { avatarAoAcaso } from './Convite.tsx';
import { FormPerfil } from './FormPerfil.tsx';
import { Tela, Topo } from './comum.tsx';

export function CriarPerfil({ sessao, aoSalvar }: { sessao: Sessao; aoSalvar: (p: PerfilConta) => void }) {
  const [ocupado, setOcupado] = useState(false);
  const [inicial] = useState<PerfilConta>(() => ({
    apelido: (sessao.nome ?? '').split(/\s+/)[0]!.slice(0, 20), avatar: avatarAoAcaso(), ...PERFIL_VAZIO,
  }));
  const google = !sessao.anonimo;
  const [celular, setCelular] = useState('');
  const [avisos, setAvisos] = useState(false);
  const [erroCelular, setErroCelular] = useState<string | null>(null);
  // O celular já gravado (o perfil não chegou a salvar da outra vez) volta preenchido.
  useEffect(() => {
    if (!google) return;
    let vivo = true;
    lerMeuCelular(sessao).then((c) => { if (vivo && c.celular) setCelular((a) => a || mascararDigitando(c.celular!)); }, () => {});
    return () => { vivo = false; };
  }, [sessao.id]);
  return (
    <Tela>
      <Topo titulo="Seu perfil de jogador" />
      <FormPerfil inicial={inicial} sessao={sessao} local botao="CONTINUAR" ocupado={ocupado} podeSalvar={!google || celularValido(celular)}
        depoisDoApelido={google && (
          <>
            <CampoCelular valor={celular} aoMudar={(v) => { setCelular(v); setErroCelular(null); }} erro={erroCelular}
              ajuda="Para contato e segurança da conta. Ninguém na mesa vê." />
            <CaixaAvisos marcada={avisos} aoMudar={setAvisos} />
          </>
        )}
        aoSalvar={async (p) => {
          setOcupado(true);
          try {
            if (google) {
              try { await guardarMeuCelular(sessao, celular, avisos); } catch (e) {
                setErroCelular(e instanceof ErroDaApi ? e.message : 'Não deu para salvar o celular. Tente de novo.');
                return;
              }
            }
            await conta.salvarPerfil(sessao, p); avisarPerfilCompleto(sessao, p); cadastrou(sessao); aoSalvar(p);
          } finally { setOcupado(false); }
        }} />
      <p className="nota">{google ? 'Você muda tudo isso depois, no Perfil. O celular, em Configurações.' : 'Você muda tudo isso depois, no Perfil.'}</p>
    </Tela>
  );
}
